import { Component } from '@angular/core';
import { TabsComponent } from '../../components/tabs/tabs.component';
import { CustomerServiceTabComponent } from './customer-service-tab.component';

@Component({
  selector: 'app-customer-service',
  standalone: true,
  imports: [TabsComponent, CustomerServiceTabComponent],
  templateUrl: './customer-service.component.html',
  styleUrl: './customer-service.component.scss',
})
export class CustomerServiceComponent {}

